import { call, put, takeLatest } from 'redux-saga/effects';

import { PolicyCommissionInvoiceApi } from '@apis/PolicyCommissionInvoiceApi';
import { PolicyCommissionInvoiceList } from '@models/PolicyCommissionInvoice';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';

import {
  policyCommissionInvoicesFetch,
  PolicyCommissionInvoicesFetchPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handlePolicyCommissionInvoicesFetchFetch({ payload }: SagaPayload<PolicyCommissionInvoicesFetchPayload>) {
  const state: StateUpdatePayload = { invoices: null, pagination: undefined };
  try {
    const [invoices, pagination] = (yield call(PolicyCommissionInvoiceApi.getAll, payload)) as [PolicyCommissionInvoiceList[], Pagination];
    state.invoices = invoices;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(policyCommissionInvoicesFetch, handlePolicyCommissionInvoicesFetchFetch);
}
